/** V2 theme bridge — wire to MUI or CSS variables later */
export const v2Theme = {
  palette: {
    primary: '#1a1a1a',
    background: '#fff7e9',
    surface: '#ffffff',
  },
};
